import IconBordered from '../IconBordered';

interface StatusTitleProps {
  title: string;
  id: string | undefined;
}

const StatusTitle: React.FC<StatusTitleProps> = ({ id, title }: StatusTitleProps) => {
  return (
    <div className='flex items-center justify-between gap-4 p-6 xl:p-8'>
      <div className='flex items-center gap-4'>
        <IconBordered>★</IconBordered>
        <p className='text-xl md:text-2xl 2xl:text-[32px] font-bold text-text-primary'>{title}</p>
      </div>
    </div>
  );
};

export default StatusTitle;
